import AntIcon from "@/components/icons/AntIcon";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { appendSearchParamsToURL, cssVariables } from "@/utils/utils";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { VehicleCategoryTabView } from "../category/components/VehicleCategoryTabView";
import { VehicleColorTabView } from "../color/components/VehicleColorTabView";
import { VEHICLE_ENUMS_TAB } from "../enums";
import { VehicleFuelTypeTabView } from "../fueltype/components/VehicleFuelTypeTabView";

export const VehicleEnumsContainer = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [urlParams] = useSearchParams();

  const tabParam = urlParams.get("tab");
  const tabKey =
    tabParam && Object.values(VEHICLE_ENUMS_TAB).includes(tabParam) ? tabParam : VEHICLE_ENUMS_TAB.CATEGORIES;

  const handleTabKeyChange = (tab: string) => {
    navigate(
      appendSearchParamsToURL({
        pageIndex: undefined,
        keyword: undefined,
        categories: undefined,
        fuelTypes: undefined,
        fuelNameSources: undefined,
        tab,
      }),
      { replace: true },
    );
  };

  return (
    <ContentWrapper>
      <Tabs
        tabBarStyle={{
          backgroundColor: "white",
          padding: "0 24px",
          marginBottom: 24,
          borderRadius: 8,
          boxShadow: `0 1px 3px 0 ${cssVariables.colorShadow}, 0 1px 2px 0 ${cssVariables.colorShadow}`,
          border: `1px solid ${cssVariables.colorHover}`,
          overflow: "hidden",
        }}
        activeKey={tabKey}
        onChange={handleTabKeyChange}
        items={[
          {
            key: VEHICLE_ENUMS_TAB.CATEGORIES,
            label: (
              <span>
                <AntIcon type="group" className="margin-right-tiny" />
                {t("vehicleCategory.titles.pageTitle")}
              </span>
            ),
            children: <VehicleCategoryTabView />,
          },
          {
            key: VEHICLE_ENUMS_TAB.COLORS,
            label: (
              <span>
                <AntIcon type="group" className="margin-right-tiny" />
                {t("vehicleColor.titles.pageTitle")}
              </span>
            ),
            children: <VehicleColorTabView />,
          },
          {
            key: VEHICLE_ENUMS_TAB.FUEL_TYPES,
            label: (
              <span>
                <AntIcon type="group" className="margin-right-tiny" />
                {t("vehicleFuelType.titles.pageTitle")}
              </span>
            ),
            children: <VehicleFuelTypeTabView />,
          },
        ]}
      />
    </ContentWrapper>
  );
};
